import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import styled from "styled-components";
import { getRecorderTimeFormat } from "utils/timeUtil";

export default function TimeText({
  times,
  timezone,
  selectedAccount,
  isThumbnail,
}: {
  times: string;
  timezone: string;
  selectedAccount: ProfileAccountInfo;
  isThumbnail: boolean;
}) {
  const getTime = getRecorderTimeFormat(times, selectedAccount, timezone, true);
  const date = getTime.split(" ")[0];
  const time = getTime.split(" ").slice(1).join(" ");
  return (
    <TimeTextContainer>
      <span>{date}</span> <span>{time}</span>
    </TimeTextContainer>
  );
}

const TimeTextContainer = styled.div`
  span {
    white-space: nowrap;
  }
`;
